import { HomeScreen } from "@/screens/home";

/** Thin wrapper — toda lógica fica em screens/home */
export function HomePage() {
  return <HomeScreen />;
}
